import React, { useState } from 'react'
import { Box, Grid2, TextField, Typography,Button,  InputAdornment,IconButton, Paper } from '@mui/material'
import { Link, useNavigate } from 'react-router-dom'
import { ErrorMessage, Field,Form,Formik } from 'formik'
import * as Yup from "yup";
import AlternateEmailIcon from "@mui/icons-material/AlternateEmail";
import KeyIcon from "@mui/icons-material/Key";
import { Visibility, VisibilityOff } from "@mui/icons-material";

import Logo from "../../Images/Nav/PSPLOGO.png"
import {toast} from "react-toastify"
// import Cookie from "js-cookie";

import { MuiOtpInput } from 'mui-one-time-password-input'
import { useDispatch, useSelector } from 'react-redux'
import { axiosPrivate } from '../../axios/axios'
import { api } from '../API/config'
import { getOTPAndEmail } from '../../Redux/authentication'
import { commonCss } from '../../StyleConfig/CommonCss'
import ErrorProps from '../../Component/Errorprops';


const GetPassword = ({login,handleCloseClick}) => {
    const [isLoading,setLoading]=useState(false)
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const userEmail =useSelector(state=>state.auth.getEmailAndOTP.emailId)
    const loginEmail=useSelector(state=>state.auth.loginInfo.emailId)
   

    const navigate=useNavigate()
  const dispatch=useDispatch()

  const initialValues = {
    emailId:login?loginEmail:userEmail,
    otp:"",
    password:"",
    confirmPassword:""

   
  };
  const onSubmit = (values, { resetForm }) => {
    setLoading(true)
    const updatePassword={
      emailId:values.emailId,
      password:values.password,
      otp:values.otp
    }
    console.log(updatePassword)
    const getLink=api.account.resetPassword
    axiosPrivate.post(`${getLink}`,updatePassword).then(res=>{
      
      console.log(res.data.data)
      dispatch(getOTPAndEmail({emailId:""}))
      toast.success("Updated")
      setLoading(false)
      if(login){
        handleCloseClick()
      }else{
     navigate("/")
      }
      // if(res.data.data.userRole===4){
      //   navigate("/user")

      // }else{
      //   navigate("/reportform")
      // }
     
      resetForm();
    }).catch(err=>{
      console.log(err)
     toast.error(
                  <Box sx={{display:"flex",flexDirection:'column'}}>
                    {
                      err.response.data.errors!==null?
                                       err.response.data.errors.map((d,i)=>(
                                         <Typography key={i}>{i+1+". "+d.errorMessage}</Typography>
                                       )):err.response.data.message
                    }
                  </Box>
                  )
      setLoading(false)
    })
   
  };
  const validationSchema = Yup.object({
    otp:Yup.string().required("OTP is required"),
    password: Yup.string().required("Password is required").matches(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{12,})/,
          "Must Contain 12 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character"
        ).matches(/^\S*$/, "White Spaces are not allowed"),
    confirmPassword: Yup.string()
      .required("Confirm Password is required")
      .oneOf([Yup.ref("password")], "Passwords must match"),
    
  });

   const handleResend = () => {
      setLoading(true);
      const getLink = api.account.forgetPassword;
      axiosPrivate
        .post(`${getLink}`, {emailId:userEmail})
        .then((res) => {
          
          toast.success("Please Check Your Email For OTP");
          setLoading(false);
          
        
        })
        .catch((err) => {
          toast.error(err.response.data.message);
          setLoading(false);
        });
    };
  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleClickShowConfirmPassword = () => setShowConfirmPassword(!showConfirmPassword);

  return (
    <Box
      sx={{
        background: login?"transparent": commonCss.normalLinearGradient,
        height: login?"auto":"100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Paper
        sx={{
          background: commonCss.shadeLinearGradient,
          p: 1,
          borderRadius: "1.5rem",
          width:login?"80%": "50%",
        }}
      >
        <Grid2 container >
        <Grid2
            container
            item
            xs={12}
            md={12}
            sx={{ padding: {xs:"2rem"} }}
            gap="1.5rem"
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                rowGap: "1.8rem",
              }}
            >
              <Link to="/">
               
                   <Box sx={{display:"flex",alignItems:"center",gap:"0.5rem"}}>
                                        {/*<img style={{width:"4vw",height:"8vh"}} src={Logo} alt='logo'/>*/}
                                      <Typography variant="h6" noWrap  sx={{fontSize:"1.4rem",color:"#ffbe0b",mt:-1}}>
                                      <span style={{color:commonCss.green}}>e</span> - PTW
                                      </Typography>
                                      </Box>
                
              </Link>
              <Box
                sx={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}
              >
                <Typography sx={{ fontWeight: 400, fontSize: "1.1rem" }}>
                                  Reset Password
                                </Typography>
                                <Typography sx={{ fontSize: "0.9rem", color: "#6C7585" }}>
                                Enter your email password and confirm password for set the password.
                                </Typography>
              </Box>
            </Box>
            <Formik
              initialValues={initialValues}
              onSubmit={onSubmit}
              validationSchema={validationSchema}
            >
             
               
                {({ setFieldValue, values, resetForm }) => (
                   <Form
                   style={{
                     display: "flex",
                     flexDirection: "column",
                     gap: "0.7rem",
                     width: "100%",
                   }}
                 >
                 <Typography sx={{color: commonCss.labelInputColor, fontWeight: 500}}>Enter OTP</Typography>
                              <Box sx={{maxWidth:login?"100%":"70%"}}>
                                <MuiOtpInput
           
                                  length={6}
                                  value={values.otp}
                                  onChange={(e) => {
                                    setFieldValue("otp", e);
                                  }}
                                  sx={{
                                    '& .MuiOutlinedInput-root': {
                                      backgroundColor: commonCss.inputBackgroundColor, 
                                      borderRadius:commonCss.inputBorderRadius
                                    },
                                    '& .MuiOutlinedInput-notchedOutline': {
                                   borderColor: commonCss.inputBorderColor, 
                                  },
                                  }}
                                />
                                <Typography sx={{ color: commonCss.green, fontWeight: 500,textAlign:"end",width:"100%",cursor:"pointer"}} onClick={handleResend}>
                  Resend
                </Typography>
                                </Box>
                                <ErrorMessage name="otp">
                                  {(error) => <ErrorProps>{error}</ErrorProps>}
                                </ErrorMessage>
                              
                <Typography sx={{ color: commonCss.labelInputColor, fontWeight: 500}}>
                  Password
                </Typography>
                <Field
                as={TextField}
                type={showPassword ? "text" : "password"}
                fullWidth
                name="password"
                size={"medium"}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    backgroundColor: commonCss.inputBackgroundColor, 
                    borderRadius:commonCss.inputBorderRadius
                  },
                  '& .MuiOutlinedInput-notchedOutline': {
                 borderColor: commonCss.inputBorderColor, 
                },
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <KeyIcon sx={{ color: commonCss.green, fontWeight: 1800 }} />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        // onMouseDown={handleMouseDownPassword}
                      >
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
                <ErrorMessage name="password">
                  {(error) => <ErrorProps>{error}</ErrorProps>}
                </ErrorMessage>
                <Typography sx={{ color: commonCss.labelInputColor, fontWeight: 500}}>
                 Confirm Password
                </Typography>
                <Field
                as={TextField}
                type={showConfirmPassword ? "text" : "password"}
                fullWidth
                name="confirmPassword"
                size={"medium"}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    backgroundColor: commonCss.inputBackgroundColor, 
                    borderRadius:commonCss.inputBorderRadius
                  },
                  '& .MuiOutlinedInput-notchedOutline': {
                 borderColor: commonCss.inputBorderColor, 
                },
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <KeyIcon sx={{ color: commonCss.green, fontWeight: 1800 }} />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowConfirmPassword}
                        // onMouseDown={handleMouseDownPassword}
                      >
                        {showConfirmPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
                <ErrorMessage name="confirmPassword">
                  {(error) => <ErrorProps>{error}</ErrorProps>}
                </ErrorMessage>
                
              <Box sx={{display:"flex",gap:"1rem",alignItems:"center"}}>
               <Button
                               type="submit"
                               variant="contained"
                               disabled={isLoading}
                               fullWidth
                               sx={{
                                 padding: "0.5rem",
                                 mt: "0.7rem",
                                 color: "white",
                                 background: isLoading
                                   ? "default"
                                   : commonCss.normalLinearGradient,
                                 "&:hover": {
                                   backgroundColor: isLoading ? "default" : commonCss.red,
                                 },
                               }}
                             >
                               Reset
                             </Button>
                             <Button
                               type="button"
                               variant="contained"
                               fullWidth
                               sx={{
                                 padding: "0.5rem",
                                 mt: "0.7rem",
                                 color: "white",
                                 display:login?"default":"none",
                                background:  commonCss.red,
                                 "&:hover": {
                                  background: commonCss.red,
                                 },
                               }}
                               onClick={handleCloseClick}
                             >
                               Close
                             </Button>
                             </Box>
                <Box sx={{display:login?"none":"flex",justifyContent:"center",alignItems:'center',mt:"1.5rem"}}>
                  <Typography sx={{color: "#6C757D"}}>Back to <Link to="/" style={{textDecoration:"none",color:commonCss.green,fontWeight:600}}>Log in</Link></Typography>
                </Box>
                </Form>
)}
            
            </Formik>
          </Grid2>
        </Grid2>
        </Paper>
    </Box>
  )
}

export default GetPassword